import type { Attraction } from '@/config/objects/attractions';
import { createEntityApi } from '@startupquickstart/frontend';

const attractionsApi = createEntityApi<Attraction>({
  resource: 'attractions',
  queryKey: 'Attraction',
});

export const useAttraction = attractionsApi.useOne;
export const useAttractions = attractionsApi.useMany;
export const useCreateAttraction = attractionsApi.useCreate;
export const useUpdateAttraction = attractionsApi.useUpdate;
export const useDeleteAttraction = attractionsApi.useDelete;
